import $ from 'jquery';
import { RouteParams } from 'universal-router';
import { Modal } from '../../modules/Modal';

import { Page } from '../Page';

export class ProductPage extends Page {
    public static render(params: RouteParams): void {
        ProductPage._addModalEventListeners();
        ProductPage._initImagesBehavior();
        ProductPage.__separeteNameForSomeNormativesName();
        ProductPage._initRelatedProductsCarousel();
    }

    private static _addModalEventListeners(): void {
        const modalContents = document.querySelector('.modal-info');

        if (modalContents === null) {
            return;
        }

        const opensModal = Array.from(document.querySelectorAll<HTMLElement>('.opens-normative-modal'));
        // const normatives = Array.from(document.querySelectorAll<HTMLElement>('.normative'));

        // opensModal.concat(normatives).forEach((element) => {
        opensModal.forEach((element) => {
            element.addEventListener('click', (e: MouseEvent) => {
                const { termId } = element.dataset;

                const contentDataContainer = modalContents.querySelector<HTMLElement>(`[data-term-id="${termId}"]`);
                const content = contentDataContainer?.querySelector<HTMLElement>('.modal-info-content');
                const icons = contentDataContainer?.querySelector<HTMLElement>('.modal-info-icons');

                Modal.open('Normativa', content ?? undefined, icons ?? undefined);
            });
        });
    }

    private static _initImagesBehavior(): void {
        ProductPage._initOwlCarousel();
        ProductPage._initLightGallery();
        ProductPage._initClickZoom();
        ProductPage._initClickMiniatures();
    }

    private static _initClickZoom(): void {
        const items = $('#images-carousel .item');
        items.on('click', function (e) {
            const item = $(this);
            const img = item.find('.img-wrapper');
            const target = $(e.target);
            if (target.hasClass('zoom-img')) {
                img.trigger('click');
            }
        });
    }

    private static _initOwlCarousel(): void {
        $('#images-carousel').owlCarousel({
            loop: false,
            margin: 0,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            mouseDrag: true,
            touchDrag: true,
            responsive: {
                0: {
                    items: 1,
                },
            },
        });

        const items = $('#images-carousel .item');
        items.on('click', function (e) {
            const item = $(this);
            const img = item.find('.img-wrapper');
            const target = $(e.target);
            if (target.hasClass('zoom-img')) {
                img.trigger('click');
            }
        });
    }

    private static _initLightGallery(): void {
        $('.file__images').not('.miniatures').lightGallery({
            download: false,
            share: false,
            rotate: false,
            autoplay: false,
            thumbnail: false,
            toogleThumb: false,
            animateThumb: false,
            controls: false,
            selector: '.img-wrapper',
        });
    }

    private static _initClickMiniatures(): void {
        const carouselImages = $('.file__images:not(miniatures) .img-wrapper');

        $('.file__images.miniatures > div').on('click', function (e) {
            const src = $(this).attr('data-src');
            if (typeof src !== 'undefined') {
                const match = ProductPage.__getCorouselImageMatch(src);
                if (match) {
                    ProductPage.__goToIndexCarousel(match - 1);
                }
            }
        });
    }

    private static __getCorouselImageMatch(src: string): number {
        const carouselImages = $('.file__images:not(miniatures) .img-wrapper');
        let index = 1;
        let find = false;
        carouselImages.each(function () {
            console.log('carouselImages');
            const carouselImageSrc = $(this).attr('data-src');
            if (src === carouselImageSrc) {
                find = true;
            } else if (!find) {
                index++;
                console.log(`no ${index}`);
            }
        });
        return find ? index : 0;
    }

    private static __goToIndexCarousel(match: number):void {
        $('#images-carousel').trigger('to.owl.carousel', [match, 300]);
    }

    private static __separeteNameForSomeNormativesName():void {
        const normativesNames = $('.normatives-wrapper .normative__text');
        normativesNames.each(function () {
            const $name = $(this);
            const text = $name.text();
            if (text.includes('EN 12477:2001+A1:2005')) {
                $name.html(ProductPage.__separateName(text));
            }
        });
    }

    private static __separateName(text: string):string {
        const firstLine = text.split('+')[0];
        const finalPart = text.split('+')[1];
        const secondLine = finalPart.split(' ')[0];
        const thirdLine = finalPart.split('(')[1];
        return `${firstLine}<br>+${secondLine}<br>(${thirdLine}`;
    }

    private static _initRelatedProductsCarousel(): void {
        const $relatedProductsWrap = $('.js-productos-relacionados');
        const $relatedProducts = $relatedProductsWrap.find('.js-item');

        if ($relatedProducts.length > 4) {
            $relatedProductsWrap.owlCarousel({
                loop: true,
                margin: 10,
                nav: true,
                dots: false,
                autoplay: false,
                mouseDrag: true,
                touchDrag: true,
                responsive: {
                    0: {
                        items: 1,
                    },
                    700: {
                        items: 2,
                    },
                    1000: {
                        items: 3,
                    },
                    1300: {
                        items: 4,
                    },
                },
            });
        }
    }
}
